
const m = window.require("dag-map");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
